"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const index_1 = __importDefault(require("@Components/WorkItem/index"));
/**
 * @deprecated Use WorkItemV2 instead
 */
const WorkItemWrapper = (props) => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { data, rightsHolderId, publicSearchType, catalogType, historyType, draftType, claimType, claimedShare, handleDeleteDraft, selectWorkForMatching, selectWorkForClaiming, } = props;
    return (react_1.default.createElement(index_1.default, { data: data, rightsHolderId: rightsHolderId, publicSearchType: publicSearchType, catalogType: catalogType, historyType: historyType, draftType: draftType, claimType: claimType, claimedShare: claimedShare, handleDeleteDraft: handleDeleteDraft, selectWorkForMatching: selectWorkForMatching, selectWorkForClaiming: selectWorkForClaiming, navigate: navigate }));
};
exports.default = WorkItemWrapper;
